import React, { useEffect } from "react";
import { Footer } from "components/Footer";
import { HeaderWithNav } from "components/HeaderWithNav";
import { HeroSection } from "components/HeroSection";
import { GetStartedSection } from "components/GetStartedSection";
import { useDynamicLanguage } from "hooks/useDynamicLanguage";
import { useScrollToElement } from "hooks/useScrollToElement";
import { LOCALE_STRINGS } from "constants/locales";
import heroImage from "assets/images/solutionTrade.svg";
import { FeatureGridSection } from "./components/FeatureGridSection";
import { FeatureListSection } from "./components/FeatureListSection";

export const SolutionsTrade = () => {
  const language = useDynamicLanguage();
  useScrollToElement();

  return (
    <>
      <HeaderWithNav />
      <div id="page" />
      <main className="main-content-wrapper home-page__main">
        <HeroSection
          imageSrc={heroImage}
          language={language}
          getStarted="getStartedTrade"
          titleKey="hero_tradeTitle"
          showStarted={true}
          showFooter={true}
        />

        <div 
          className="title-with-subtitle mb-12 text-center mx-auto w-full"
          style={{ maxWidth: "1050px", marginTop: "40px" }}
        >
          <h2 className="title" style={{ maxWidth: "100%" }}>
            {LOCALE_STRINGS[language]?.homePage_solutionsTrade_title}
          </h2>
          <p className="text-small" style={{ maxWidth: "100%" }}>
            {LOCALE_STRINGS[language]?.homePage_solutionsTrade_description}
          </p>
        </div>

        <FeatureGridSection language={language} />
        <FeatureListSection language={language} />
        <GetStartedSection language={language} />
      </main>
      <Footer />
    </>
  );
};